"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcelModal = exports.ApplySaveJSONDialog = exports.ApplyLayoutDialog = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const types_1 = require("./types");
const SankeyLayout_1 = require("./SankeyLayout");
const SankeyConvert_1 = require("./SankeyConvert");
const SankeyUtils_1 = require("./SankeyUtils");
/**
 * Define ApplyLayoutDialog
 *
 * @type {{ show_apply_layout: any; set_show_apply_layout: any; sankey_data: any; set_sankey_data: any; }}
 */
const ApplyLayoutDialogPropTypes = {
    t: prop_types_1.default.func.isRequired,
    show_apply_layout: prop_types_1.default.bool.isRequired,
    set_show_apply_layout: prop_types_1.default.func.isRequired,
    sankey_data: types_1.SankeyDataPropTypes,
    set_sankey_data: prop_types_1.default.func.isRequired
};
/**
 *
 * @param {ApplyLayoutDialogTypes} { show_apply_layout, set_show_apply_layout, sankey_data, set_sankey_data }
 * @returns {*}
 */
const ApplyLayoutDialog = ({ t, show_apply_layout, set_show_apply_layout, sankey_data, set_sankey_data }) => {
    const [file_layout, set_file_layout] = react_1.useState(undefined);
    const [elementToDispose, set_elementToDispose] = react_1.useState(['']);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { size: "xl", show: show_apply_layout, onHide: () => set_show_apply_layout(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.amp'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.fmep'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => set_file_layout(evt.target.files) })),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                                if (file_layout === undefined) {
                                    return;
                                }
                                const reader = new FileReader();
                                reader.onload = (() => {
                                    return ((e) => {
                                        let result = e.target.result;
                                        if (result) {
                                            result = String(result); //.split('<br>').join('\\\\n')
                                            const new_layout = JSON.parse(result);
                                            SankeyConvert_1.convert_data(new_layout);
                                            SankeyConvert_1.complete_sankey_data(new_layout, SankeyUtils_1.default_sankey_data, SankeyUtils_1.default_node, SankeyUtils_1.default_link);
                                            SankeyLayout_1.updateLayout(sankey_data, new_layout, elementToDispose);
                                            set_sankey_data(Object.assign({}, sankey_data));
                                        }
                                    });
                                })();
                                reader.readAsText(file_layout[0]);
                            } }, t('Menu.ad'))))),
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Menu.textDisposition')),
            react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row, onClick: () => {
                    set_sankey_data(Object.assign({}, sankey_data));
                } },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, checked: elementToDispose.includes('posNode'), value: 'posNode', label: t('Menu.PosNoeud'), onChange: (evt) => {
                            if (evt.target.checked) {
                                elementToDispose.push('posNode');
                                set_elementToDispose(elementToDispose);
                            }
                            else {
                                elementToDispose.splice(elementToDispose.indexOf('posNode'), 1);
                                set_elementToDispose(elementToDispose);
                            }
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, checked: elementToDispose.includes('attrNode'), value: 'attrNode', label: t('Menu.attrNode'), onChange: (evt) => {
                            if (evt.target.checked) {
                                elementToDispose.push('attrNode');
                                set_elementToDispose(elementToDispose);
                            }
                            else {
                                elementToDispose.splice(elementToDispose.indexOf('attrNode'), 1);
                                set_elementToDispose(elementToDispose);
                            }
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, checked: elementToDispose.includes('attrFlux'), value: 'attrFlux', label: t('Menu.attrFlux'), onChange: (evt) => {
                            if (evt.target.checked) {
                                elementToDispose.push('attrFlux');
                                set_elementToDispose(elementToDispose);
                            }
                            else {
                                elementToDispose.splice(elementToDispose.indexOf('attrFlux'), 1);
                                set_elementToDispose(elementToDispose);
                            }
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, checked: elementToDispose.includes('tagNode'), value: 'tagNode', label: t('Menu.tagNode'), onChange: (evt) => {
                            if (evt.target.checked) {
                                elementToDispose.push('tagNode');
                                set_elementToDispose(elementToDispose);
                            }
                            else {
                                elementToDispose.splice(elementToDispose.indexOf('tagNode'), 1);
                                set_elementToDispose(elementToDispose);
                            }
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, checked: elementToDispose.includes('tagFlux'), value: 'tagFlux', label: t('Menu.tagFlux'), onChange: (evt) => {
                            if (evt.target.checked) {
                                elementToDispose.push('tagFlux');
                                set_elementToDispose(elementToDispose);
                            }
                            else {
                                elementToDispose.splice(elementToDispose.indexOf('tagFlux'), 1);
                                set_elementToDispose(elementToDispose);
                            }
                        } })),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, checked: elementToDispose.includes('attrGeneral'), value: 'attrGeneral', label: t('Menu.attrGeneral'), onChange: (evt) => {
                            if (evt.target.checked) {
                                elementToDispose.push('attrGeneral');
                                set_elementToDispose(elementToDispose);
                            }
                            else {
                                elementToDispose.splice(elementToDispose.indexOf('attrGeneral'), 1);
                                set_elementToDispose(elementToDispose);
                            }
                        } }))))));
};
exports.ApplyLayoutDialog = ApplyLayoutDialog;
/**
 *
 * @type {{ show_save_json: any; set_show_save_json: any; sankey_data: any; set_sankey_data: any; clickSaveDiagram: any; }}
 */
const ApplySaveJSONPropTypes = {
    t: prop_types_1.default.func.isRequired,
    show_save_json: prop_types_1.default.bool.isRequired,
    set_show_save_json: prop_types_1.default.func.isRequired,
    sankey_data: types_1.SankeyDataPropTypes,
    set_sankey_data: prop_types_1.default.func.isRequired,
};
/**
 *
 * @param {ApplySaveJSONTypes} { show_save_json, set_show_save_json,sankey_data,set_sankey_data,clickSaveDiagram }
 * @returns {*}
 */
const ApplySaveJSONDialog = ({ t, show_save_json, set_show_save_json, sankey_data, set_sankey_data }) => {
    const [mode_save, set_mode_save] = react_1.useState(true);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_save_json, onHide: () => set_show_save_json(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.SaveJSON'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: 'switch', style: { marginTop: '-0.25em', marginBottom: '0em' }, checked: mode_save, onChange: (evt) => set_mode_save(evt.target.checked) })),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'left', marginLeft: '-2.75em' } }, t('Menu.SaveValue'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                                // Crée une copie pour d'abord enregitrer avec les changements
                                // (clickSaveDiagram utilise data donc on doit faire un set_data avant mais aussi garder la version sans les changements)
                                const cpy = JSON.parse(JSON.stringify(sankey_data));
                                if (!mode_save) {
                                    Object.values(sankey_data.links).map(d => {
                                        d.value = {};
                                        return d;
                                    });
                                }
                                set_sankey_data(Object.assign({}, sankey_data));
                                SankeyUtils_1.clickSaveDiagram(sankey_data);
                                set_sankey_data(Object.assign({}, cpy));
                            } }, t('Menu.SaveJSON'))))))));
};
exports.ApplySaveJSONDialog = ApplySaveJSONDialog;
const ExcelModalPropTypes = {
    t: prop_types_1.default.func.isRequired,
    uploadExcelImpl: prop_types_1.default.func.isRequired,
    handleCloseDialog: prop_types_1.default.func.isRequired,
    set_data: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    show_excel_dialog: prop_types_1.default.bool.isRequired,
    set_show_excel_dialog: prop_types_1.default.func.isRequired,
    url_prefix: prop_types_1.default.string.isRequired,
    callback: prop_types_1.default.func.isRequired,
    launch: prop_types_1.default.func.isRequired
};
/**
 * Return the modal when we try to open an excel file
 *
 * @param {{ uploadExcelImpl: any; handleCloseDialog: any; set_data: any; data: any; set_show_excel_dialog: any; url_prefix: any; callback: any; launch: any; }} { uploadExcelImpl, handleCloseDialog, set_data, data, set_show_excel_dialog,url_prefix,callback,launch }
 * @returns
 */
const ExcelModal = ({ t, uploadExcelImpl, handleCloseDialog, set_data, data, show_excel_dialog, set_show_excel_dialog, url_prefix, callback, launch }) => {
    const [input_file_name, set_input_file_name] = react_1.useState(undefined);
    const [layout_file, set_layout_file] = react_1.useState(undefined);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_excel_dialog, onHide: handleCloseDialog },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Ouvrir Fichier Excel")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Fichier d'entr\u00E9e excel"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => {
                            set_input_file_name(evt.target.files[0]);
                        } })),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Diagramme de mise en page"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", 
                        //ref={layout_file_}
                        name: "", onChange: (evt) => {
                            set_layout_file(evt.target.files[0]);
                        } })))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                    if (layout_file !== undefined) {
                        const reader = new FileReader();
                        reader.onload = (() => {
                            return ((e) => {
                                let result = e.target.result;
                                if (result) {
                                    result = String(result); //.split('<br>').join('\\\\n')
                                    const layout = JSON.parse(result);
                                    data.layout = layout;
                                    launch('');
                                    uploadExcelImpl(data, set_data, set_show_excel_dialog, input_file_name, url_prefix, callback);
                                }
                            });
                        })();
                        reader.readAsText(layout_file);
                    }
                    else {
                        launch('');
                        uploadExcelImpl(data, set_data, set_show_excel_dialog, input_file_name, url_prefix, callback);
                    }
                } }, "Ouvrir"),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: handleCloseDialog }, t('Menu.ca')))));
};
exports.ExcelModal = ExcelModal;
exports.ExcelModal.propTypes = ExcelModalPropTypes;
